import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Divider, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Tooltip, message, Modal, Checkbox } from 'antd'
import { DeleteOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Table, Tag} from 'antd';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';


export default function Department(){
    const createDepartment = useStoreActions((state) => state.student.createDepartment);
    const updateDepartment = useStoreActions((state) => state.student.updateDepartment);
    const deleteDepartment = useStoreActions((state) => state.student.deleteDepartment);
    const fetchDepartmentList = useStoreActions((state) => state.student.fetchDepartmentList);
    const departmentList = useStoreState((state) => state.student.departmentList);
    const [departmentForm] = Form.useForm();
    const [updateForm] = Form.useForm();

    ///modal
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedStatus, setselectedStatus] = useState<any>();
    const [updateDepartmentId, setupdateDepartmentId] = useState<any>();

    useEffect(() => {
        fetchDepartmentList();
        
    },[])

    const createDepartmentForm = (value) => {
        
        let postData = {
            name: value.departmentName,
            serial: value.serialNumber,
            status: 1
        }
        
        createDepartment(postData);
        departmentForm.resetFields();
    }

    /////////////

    const updateDepartmentForm = (value) => {
        let updatePostData = {
            id:updateDepartmentId,
            name: value.name,
            serial: value.serial,
            status: value.status == true ? 1 : 0
        }
        updateDepartment(updatePostData);
        setIsModalVisible(false);
        updateForm.resetFields();
    }

    

    const success = () => {
        message.success('This is a success message');
      };
      
      const columns = [
        {
            title: 'Serial',
            dataIndex: 'serial',
            key: 'serial',
            showOnResponse: true,
            showOnDesktop: true
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            showOnResponse: true,
            showOnDesktop: true
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            showOnResponse: true,
            showOnDesktop: true,
            render: (text: any, record: any, index) => (
                <>
                   <span>{ record.status == 1 ? 'Enable' : 'Disable'}</span>
                </>
            )
        },
        {
            title: 'Action',
            key: 'ledgerId',
            showOnResponse: true,
            showOnDesktop: true,
            render: (text: any, record: any, index) => (
                <Space size="middle">
                    <Tooltip title="Edit">
                        <Button type='primary' icon={<EditOutlined />} onClick={() => {
                            setIsModalVisible(true);
                            setselectedStatus(record.status);
                            setupdateDepartmentId(record.id);
                            updateForm.setFieldsValue({
                                serial: record.serial,
                                name: record.name,
                                status: record.status,
                            });
                        }} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => deleteDepartment(record?.id)}
                    >
                        <Tooltip title="Delete">
                            <Button danger  icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>

                </Space>
            ),
        }
      ];
    return(
        <>
            <Row>
                <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24}} lg={{ span: 12, offset: 6 }} xl={{ span: 12, offset: 6 }}>
                    <Form
                        layout="vertical"
                        id="departmentInfo"
                        onFinish={createDepartmentForm}
                        form={departmentForm}
                    >
                        <Row>
                            <Col xs={{ span: 24}} sm={{ span: 24}} md={{ span: 10}} lg={{ span: 10 }} xl={{ span: 10 }}>
                                <Form.Item
                                        name="departmentName"
                                        label="Department Name"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please write department name" },
                                        ]}
                                    >
                                    <Input placeholder="Enter department name" />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24}} sm={{ span: 24}} md={{ span: 10}} lg={{ span: 10 }} xl={{ span: 10 }}>
                                <Form.Item
                                        name="serialNumber"
                                        label="Serial Number"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please write serial number" },
                                        ]}
                                    >
                                    <InputNumber placeholder="Enter serial number" />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24}} sm={{ span: 24}} md={{ span: 4}} lg={{ span: 4 }} xl={{ span: 4 }}>
                                <Space size="small" >
                                    <Button type="primary" htmlType="submit" icon={<SaveOutlined />} >
                                        Save
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <Row className="m-t-mo-30">
                <Col span="24">
                    <div className="datatable-responsive-demo">
                        {/* <Table bordered={true} ledgerList={ledgerList} columns={columns} departmentName="p-datatable-responsive-demo" /> */}
                        <Table bordered={true} dataSource={departmentList} columns={columns} className="p-datatable-responsive-demo" />
                    </div>
                </Col>
            </Row>
            <Modal
                title="Department Edit"
                visible={isModalVisible}
                //  onOk={handleOk}
                okButtonProps={{ form: 'update', htmlType: 'submit' }}
                onCancel={() => setIsModalVisible(false)}
                cancelText="Close"
                okText="Update"
                centered
            >
                <Form
                        layout="vertical"
                        id="update"
                        onFinish={updateDepartmentForm}
                        form={updateForm}
                    >
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                        name="name"
                                        label="Department Name"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please write department name" },
                                        ]}
                                    >
                                    <Input placeholder="Enter department name" />
                                </Form.Item>
                            </Col> 
                            <Col span={24}>
                                <Form.Item
                                        name="serial"
                                        label="Serial Number"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please write serial number" },
                                        ]}
                                    >
                                    <InputNumber placeholder="Enter serial number" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                    <Form.Item
                                        name="status"
                                        label="Status:"
                                        valuePropName="checked"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please input serial" },
                                        ]}
                                    >
                                    <Checkbox>Enable</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
            </Modal>
        </>
    )
    
}